import { IGallery } from '../../modules/reducers/galleries';

// The Settings tab shows one global "download" / "watermark" switch for the
// whole collection; it reads as ON only while EVERY album has it on.
export const areAllGalleriesDownloadable = (galleries: IGallery[]) =>
  galleries.every((gallery) => Boolean(gallery.download));

// Watermark id shared by all albums, or '' when at least one album has none
// (or there are no albums yet).
export const getSharedGalleriesWatermarkId = (galleries: IGallery[]) =>
  galleries.length && galleries.every((gallery) => Boolean(gallery._watermark))
    ? galleries[0]._watermark
    : '';
